export class VisualContentError {
  constructor(
    readonly icon: string,
    readonly message: string) { }
}

export namespace VisualContentError {
  export const Generic = new VisualContentError(
    "fa-exclamation-triangle",
    "An unexpected error occurred while loading the visual. <br> Please try again or contact support if the issue continues.");

  export const NoData = new VisualContentError(
    "fa-server",
    "The dataset returned no results. <br> Try adjusting filters or adding fields to view data.");

  export const ToMuchData = new VisualContentError(
    "fa-server",
    "The dataset is too large to display. <br> Please apply filters or reduce the fields shown.");
}

